import { GamesOrderType, SelectedGame } from "entities/modules/types";
import { create } from "zustand";

export type SelectedGamesDataStore = {
  orderType: GamesOrderType;
  selectedGames: SelectedGame[];
  selectedGamesByTag: SelectedGame[];
  selectedGamesManually: SelectedGame[];
  setOrderType: (orderType: GamesOrderType) => void;
  setSelectedGames: (selectedGames: SelectedGame[]) => void;
  setSelectedGamesByTag: (selectedGamesByTag: SelectedGame[]) => void;
  setSelectedGamesManually: (selectedGamesManually: SelectedGame[]) => void;
  clearSelectedGamesData: () => void;
};

export const useSelectedGamesData = create<SelectedGamesDataStore>((set) => ({
  orderType: GamesOrderType.Random,
  selectedGamesByTag: [],
  selectedGamesManually: [],
  selectedGames: [],
  setOrderType: (orderType) => set({ orderType }),
  setSelectedGames: (selectedGames) => set({ selectedGames }),
  setSelectedGamesByTag: (selectedGamesByTag) => set({ selectedGamesByTag }),
  setSelectedGamesManually: (selectedGamesManually) =>
    set({ selectedGamesManually }),
  clearSelectedGamesData: () =>
    set({
      orderType: GamesOrderType.Random,
      selectedGames: [],
      selectedGamesByTag: [],
      selectedGamesManually: [],
    }),
}));
